// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__31jcE","location":"Header_location__1kxoI"};